(() => {
  const mobile = window.matchMedia('(max-width: 749px)');
  const purchaseAreas = new Set();
  let entrypoint;
  const update = () => {
    if (entrypoint) entrypoint.style.setProperty('visibility', mobile.matches && purchaseAreas.size ? 'hidden' : 'visible', 'important');
  };
  const areas = new IntersectionObserver(entries => {
    entries.forEach(entry => entry.isIntersecting ? purchaseAreas.add(entry.target) : purchaseAreas.delete(entry.target));
    update();
  }, { threshold: 0 });
  document.querySelectorAll('.product-information').forEach(area => areas.observe(area));
  const mount = () => {
    const root = document.getElementById('ads-agent-host')?.shadowRoot;
    if (!root) return;
    entrypoint = root.querySelector('[data-testid="entrypoint"]');
    if (!root.getElementById('hc-mobile-purchase-spacing')) {
      const style = document.createElement('style');
      style.id = 'hc-mobile-purchase-spacing';
      style.textContent = '@media(max-width:749px){[data-testid="entrypoint"]{transform:none!important;bottom:calc(12px + env(safe-area-inset-bottom))!important;right:12px!important;margin:0!important;max-width:calc(100vw - 24px)!important}}';
      root.appendChild(style);
      new MutationObserver(() => {
        entrypoint = root.querySelector('[data-testid="entrypoint"]');
        update();
      }).observe(root, { childList: true, subtree: true });
    }
    update();
  };
  const hosts = new MutationObserver(mount);
  hosts.observe(document.body, { childList: true });
  mobile.addEventListener('change', update);
  mount();
})();
